var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariantImageCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.408 0 16 3.592 16 8C16 12.408 12.408 16 8 16C3.592 16 0 12.408 0 8C0 3.592 3.592 0 8 0ZM5.34117 4.50631C5.10733 4.34431 4.78401 4.36746 4.57573 4.57574C4.34141 4.81005 4.34141 5.18995 4.57573 5.42426L7.151 8L4.57573 10.5757L4.5063 10.6588C4.34431 10.8927 4.36745 11.216 4.57573 11.4243C4.81004 11.6586 5.18996 11.6586 5.42427 11.4243L8 8.849L10.5757 11.4243L10.6588 11.4937C10.8927 11.6557 11.216 11.6325 11.4243 11.4243C11.6586 11.1899 11.6586 10.8101 11.4243 10.5757L8.849 8L11.4243 5.42426L11.4937 5.34117C11.6557 5.10732 11.6326 4.78402 11.4243 4.57574C11.19 4.34142 10.81 4.34142 10.5757 4.57574L8 7.151L5.42427 4.57574L5.34117 4.50631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariantImageCrossIcon);
export default __webpack_public_path__ + "static/media/variant-image-cross-icon.12a9590ead597a42045f23f9f4f2ed64.svg";
export { ForwardRef as ReactComponent };